export const FEATURE_FLAGS = {
  suggestChange: {
    description: 'Suggest Change Web-Form',
    jiraLink: 'https://jira.fishbrain.com/browse/FB-39052',
  },
  heic: {
    description: 'test heic image upload',
    jiraLink: 'https://fishbrain.atlassian.net/browse/FIB-41691',
  },
  zendesk: {
    description: 'Zendesk',
    jiraLink: 'https://fishbrain.atlassian.net/browse/FIB-45654',
  },
  newFishingSpots: {
    description: 'New Fishing Spots Page',
    jiraLink: 'https://fishbrain.atlassian.net/browse/FIB-45088',
  },
} as const;

// 'test' and 'test2' is needed for the unit tests - should not be used for actual feature flags.
export type FeatureFlag = keyof typeof FEATURE_FLAGS | 'test' | 'test2';
